export const environment = {
  production: false,
  web: 'https://localhost:4900/',
  // api: 'http://localhost:52624/',
  api: 'https://empresaconvenioapidev.uninter.com/',
  ambiente: 'DEV',
  apiAccount: 'http://localhost:52453/',
  webAccount: 'https://accountdev.uninter.com/',
  loginUnificadoUrl: 'http://localhost:3000'
};